import React from 'react';
import { FC } from 'react';
import { CloseIconDark } from 'src/assets/images';
import { ShowIf } from '../../../../components';
import { QuantityCounterInput, QuantitySpinInput } from '../../../common';
import './solution-summary-card-input.scss';

type SolutionSummaryCardInputProps = {
  name: string;
  image: string;
  title: string;
  price: number;
  min: number;
  max: number;
  priceString: string;
  onRemoved: () => void;
  showRemoveButton: boolean;
  showInput?: boolean;
  disableQuantity?: boolean;
  automationid: string;
  /**
   *  Optional function will be called when control value changes.
   *
   *  @param value - the new control value
   *  @returns false or undefined if the new control value should be
   *  discarded.
   *  @returns true otherwise.
   *
   * @param value
   */
  onModified?: (value: number) => boolean | undefined;
};

export const SolutionSummaryCardInput: FC<SolutionSummaryCardInputProps> = ({
  image = '',
  title = '',
  priceString = '',
  automationid,
  onRemoved = () => {},
  showRemoveButton,
  showInput = true,
  disableQuantity,
  ...props
}) => {
  return (
    <section id="sol-summary-card">
      <section className="product-image-box">
        <img src={image} alt="Icon" className="product-image" />
      </section>
      <section className="content-box">
        <div>
          <p>{title}</p>
          <p className="is-hidden-tablet price-tag">{priceString}</p>
        </div>
        {showInput && (
          <>
            <QuantitySpinInput
              className="is-hidden-mobile"
              automationid={automationid}
              disabled={disableQuantity}
              lightMode
              {...props}
            />
            <QuantityCounterInput
              className="is-hidden-tablet"
              disabled={disableQuantity}
              automationid={automationid}
              {...props}
            />
          </>
        )}
      </section>
      <p className="is-hidden-mobile">{priceString}</p>

      <ShowIf condition={showRemoveButton}>
        <img src={CloseIconDark} alt="X" onClick={onRemoved} className="close-icon" />
      </ShowIf>
    </section>
  );
};
